import { render, staticRenderFns } from "./TenantLogin.vue?vue&type=template&id=1b97c271&scoped=true"
import script from "./TenantLogin.vue?vue&type=script&lang=js"
export * from "./TenantLogin.vue?vue&type=script&lang=js"
import style0 from "./TenantLogin.vue?vue&type=style&index=0&id=1b97c271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97c271",
  null
  
)

export default component.exports